import React from 'react'
import { useHistory } from 'react-router-dom'
import { GpButton, Icon } from '../components/gp'

/*
 * NotFound. Branded 404 catch all. Light surface, IBM Plex Sans,
 * --gp-* tokens, brand green CTA.
 */
const NotFound = () => {
    const history = useHistory()

    return (
        <div
            className="gp-app"
            style={{
                minHeight: '70vh',
                background: 'var(--gp-bg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '64px 20px',
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: 520,
                    textAlign: 'center',
                }}
            >
                {/* Icon medallion */}
                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 84,
                        height: 84,
                        borderRadius: '50%',
                        background: 'var(--gp-lime-soft)',
                        color: 'var(--gp-brand)',
                        marginBottom: 24,
                    }}
                >
                    <Icon name="plug" size={38} />
                </span>

                <div
                    style={{
                        font: 'var(--gp-display)',
                        fontSize: 72,
                        lineHeight: 1,
                        color: 'var(--gp-brand)',
                        marginBottom: 12,
                    }}
                >
                    404
                </div>

                <h1
                    style={{
                        font: 'var(--gp-h1)',
                        color: 'var(--gp-ink)',
                        margin: '0 0 10px',
                    }}
                >
                    Page not found
                </h1>

                <p
                    style={{
                        font: 'var(--gp-body)',
                        color: 'var(--gp-ink-mute)',
                        margin: '0 auto 28px',
                        maxWidth: 380,
                    }}
                >
                    The page you're looking for doesn't exist or may have been
                    moved. Let's get you back on track.
                </p>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <GpButton
                        variant="primary"
                        icon="home"
                        onClick={() => history.push('/')}
                    >
                        Back home
                    </GpButton>
                </div>
            </div>
        </div>
    )
}

export default NotFound
